import { useQuery } from '@tanstack/react-query';
import { supabase } from '../lib/supabase';
import { useCurrentCompany } from './useCurrentCompany';

export interface DiscountCode {
  id: string;
  code: string;
  description: string | null;
  discount_type: string;
  discount_value: number;
  duration_type: string;
  duration_months: number | null;
  max_redemptions: number | null;
  expires_at: string | null;
  created_at: string | null;
  is_active: boolean;
}

export function useDiscountCodes() {
  const { data: companyId } = useCurrentCompany();

  return useQuery({
    queryKey: ['discount-codes', companyId],
    enabled: !!companyId,
    queryFn: async (): Promise<DiscountCode[]> => {
      if (!companyId) return [];

      const { data, error } = await supabase
        .from('discount_codes')
        .select('id, code, description, discount_type, discount_value, duration_type, duration_months, max_redemptions, expires_at, created_at, is_active')
        .eq('company_id', companyId)
        .order('created_at', { ascending: false });

      if (error) throw error;
      return (data ?? []) as DiscountCode[];
    },
    staleTime: 60 * 1000,
  });
}
